import type { MarkdownOverrides } from "@expert/solve-tools";
import type { DividerProps, TextProps } from "@mantine/core";
import type { JSX, ReactNode } from "react";

import { Box, Divider, List, Text } from "@mantine/core";

import styles from "./markdownOverrides.module.css";

function ProactiveGuidanceMarkdownWrapper({ children }: { children: ReactNode }): JSX.Element {
    return <Box px="0">{children}</Box>;
}

function H1Override(props: TextProps) {
    return <Text component="h1" size="xl" fw={700} pt="sm" pb="sm" lh="lg" {...props} />;
}

function H2Override(props: TextProps) {
    return <Text component="h2" size="lg" fw={700} pt="sm" pb="sm" {...props} />;
}

function H3Override(props: TextProps) {
    return <Text component="h3" size="md" fw={700} pt="sm" pb="xs" {...props} />;
}

function DividerOverride(props: DividerProps) {
    return <Divider color="primary.4" w="80%" mt="xs" mb="xs" {...props} />;
}

const listOverride: MarkdownOverrides = {
    ol: {
        component: List,
        props: {
            type: "ordered",
            size: "sm",
            spacing: "3xs",
            withPadding: false,
            className: styles.list,
        },
    },
    ul: {
        component: List,
        props: {
            type: "unordered",
            listStyleType: "disc",
            size: "sm",
            spacing: "3xs",
            withPadding: false,
            className: styles.list,
        },
    },
    li: {
        component: List.Item,
    },
};

export const markdownOverrides: MarkdownOverrides = {
    ...listOverride,
    hr: { component: DividerOverride },
    h1: { component: H1Override },
    h2: { component: H2Override },
    h3: { component: H3Override },
};

export const proactiveGuidanceMarkdownOptions = {
    wrapper: ProactiveGuidanceMarkdownWrapper,
    overrides: markdownOverrides,
};
